import { defineStore } from 'pinia';
import { filterAllowedFields } from '@src/helpers/apiUtils.js';
import axios from 'axios';

export const useUserStore = defineStore('userStore', {
    state: () => ({
        list: null,
        user: null,
        deliveryAddresses: null,
        userModel: {
            id: null,
            customer_id: null,
            name: null,
            email: null,
            phone_mobile: null,
            phone_landline: null,
            delivery_addresses: [],
            groups: [],
            groups_id: [],
            referent_code: null
        }
    }),

    actions: {
        async fetchUserList(params = {}) {
            const { data } = await axios.get(`users`, { params });
            this.list = data.records;
            return data;
        },

        async fetchUser(id) {
            // console.log('--- fetchUser');
            const params = {};
            params.includes = ['groups', 'deliveryAddresses'];

            const { data } = await axios.get(`users/${id}`, { params });
            this.user = data;
        },

        async fetchUserDeliveryAddressList(params) {
            // console.log('---fetchUserDeliveryAddresses');
            const { data } = await axios.get(`delivery-addresses`, { params });
            this.deliveryAddresses = data.records;
            return data;
        },

        async searchUser(params) {
            params.includes = [];
            const { data } = await axios.get('users', { params });
            return data;
        },

        addUser(customerId) {
            this.user = { ...this.userModel };
            this.user.customer_id = customerId;
        },

        async saveUser(user) {
            const allowedFields = ['id', 'name', 'surname', 'email', 'password', 'phone_landline', 'phone_mobile', 'referent_code', 'groups_id', 'delivery_addresses_id', 'customer_id'];
            const payload = filterAllowedFields(user, allowedFields);

            const params = {};
            params.includes = ['groups', 'deliveryAddresses'];

            const { data } = await axios.post('users', payload, { params });
            this.user = data;
            return data;
        },

        async removeUser(id) {
            await axios.delete(`users/${id}`);
        }
    }
});
